import type { Step } from '@/user/address-book/types'

export const mapHeight: Record<Step, string> = {
  WHERE_TO_DELIVER: '50%',
  FIND_ADDRESS_ON_MAP: '155px',
  FIND_ADDRESS_BY_TEXT: '50%',
  ADDRESS_TYPE_FORM: '260px',
  ADDRESS_DETAILS_FORM: '50%',
  SET_ENTRANCE: '0%',
}

export const sheetHeight: Record<Step, string> = {
  WHERE_TO_DELIVER: '50%',
  FIND_ADDRESS_ON_MAP: '155px',
  FIND_ADDRESS_BY_TEXT: '100%',
  ADDRESS_TYPE_FORM: '260px',
  ADDRESS_DETAILS_FORM: '100%',
  SET_ENTRANCE: '100%',
}
